export default "__VITE_ASSET__e2462ac9__"